import { render, staticRenderFns } from "./Invitee.vue?vue&type=template&id=3b9dc162&scoped=true&"
import script from "./Invitee.vue?vue&type=script&lang=js&"
export * from "./Invitee.vue?vue&type=script&lang=js&"
import style0 from "./Invitee.vue?vue&type=style&index=0&id=3b9dc162&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dc162",
  null
  
)

export default component.exports